module.exports = __webpack_public_path__ + "media/images/products/category/sm/7-dc9f8a41d6c01bea6fe64e5201626b3b.jpg";